import * as React from "react";

interface GenCheckboxFilterProps extends ConnectedListFilterInterface {
  label: string;
  filterKey: string;
  option: Filter;
}

export default function GenCheckboxFilter(props: GenCheckboxFilterProps) {
  const {
    label,
    filterKey,
    option,
    activeFilters = {},
    addListFilter,
    removeListFilter,
    resetListPages,
    readListPage,
  } = props;

  const value = !!activeFilters[filterKey];

  return(
    <div className="gen-checkbox-filter my-2">
      <label>
        <input
          id={filterKey}
          name={label}
          type="checkbox"
          checked={value}
          onChange={() => {
            value ? removeListFilter(filterKey) : addListFilter(filterKey, option);
            resetListPages();
            readListPage();
          }}
        />
        {label}
      </label>
    </div>
  );
}
